exports.components = {
  "component---src-page-main-page-js": () => import("./../../../src/page/main/page.js" /* webpackChunkName: "component---src-page-main-page-js" */),
  "component---src-page-not-found-page-js": () => import("./../../../src/page/notFound/page.js" /* webpackChunkName: "component---src-page-not-found-page-js" */),
  "component---src-page-post-page-js": () => import("./../../../src/page/post/page.js" /* webpackChunkName: "component---src-page-post-page-js" */)
}

